namespace $.$$ {

	export class $shm_hitalama_agent_endpoint extends $mol_object2 {

		static agent_domain_default() {
			return 'crus.51-250-36-140.ip.hyoo.ru'
		}

		static online_agent( next?: boolean ) {
			return $mol_state_local.value< boolean >( '$' + 'hitalama_domain_page_online_agent', next ) ?? false
		}

		static agent_domain_suffix() {
			const location = $mol_dom_context.document?.location
			if( location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
				return '158-160-195-195.ip.hyoo.ru'
			}
			if( location?.protocol === 'https:' && location.hostname === 'dashboard.shmakov.media' ) {
				return this.agent_domain_default()
			}
			if( this.online_agent() ) return this.agent_domain_default()
			return ''
		}

		static agent_url( subdomain: string, local: string ) {
			const settings = ( this.$ as any ).$shm_hitalama_settings
			const stored = String( settings?.agent_url?.() ?? '' ).trim()
			if( stored ) return this.authorized_url( stored )
			const backend = this.agent_backend()
			if( backend !== 'opencode' ) {
				const fallback = $shm_hitalama_agent_provider.url_default( backend )
				if( fallback ) return this.authorized_url( fallback )
				throw new Error( `Для ${ $shm_hitalama_agent_provider.info( backend ).title } не задан URL моста` )
			}
			const suffix = this.agent_domain_suffix()
			return this.authorized_url( suffix ? `https://${ subdomain }.${ suffix }` : local )
		}

		static agent_backend(): $shm_hitalama_agent_backend {
			const settings = ( this.$ as any ).$shm_hitalama_settings
			return $shm_hitalama_agent_provider.normalize( settings?.agent_backend?.() )
		}

		static authorized_url( url: string ) {
			const settings = ( this.$ as any ).$shm_hitalama_settings
			const backend = this.agent_backend()
			const token = String( settings?.agent_token?.() ?? '' ).trim()
			if( $shm_hitalama_agent_provider.info( backend ).token_required && !token ) {
				throw new Error( `Для ${ $shm_hitalama_agent_provider.info( backend ).title } не задан токен` )
			}
			$shm_hitalama_agent_api.header_provider( url, (): Record< string, string > => {
				const current = String( settings?.agent_token?.() ?? '' ).trim()
				return $shm_hitalama_agent_provider.api_headers( this.agent_backend(), current )
			} )
			return url
		}

		static agent_token_required() {
			const backend = this.agent_backend()
			if( !$shm_hitalama_agent_provider.info( backend ).token_required ) return
			const settings = ( this.$ as any ).$shm_hitalama_settings
			if( String( settings?.agent_token?.() ?? '' ).trim() ) return
			throw new Error( `Для ${ $shm_hitalama_agent_provider.info( backend ).title } не задан токен` )
		}

		static agent_preview_url( path: string ) {
			const module = path.replace( /^\/+|\/+$/g, '' )
			if( !module ) return 'about:blank'
			const suffix = this.agent_domain_suffix()
			const host = suffix ? `https://devserver.${ suffix }` : 'http://localhost:9080'
			return `${ host }/${ module }/-/test.html`
		}

		static mcp_url() {
			return this.mcp_http_url( this.$.$shm_hitalama_settings.agent_mcp_url() )
		}

		static mcp_http_url( url: string ) {
			const parsed = new URL( url, $mol_dom_context.document?.location.href )
			if( parsed.protocol === 'ws:' ) parsed.protocol = 'http:'
			if( parsed.protocol === 'wss:' ) parsed.protocol = 'https:'
			parsed.pathname = parsed.pathname.replace( /\/hitalama-mcp$/, '' ).replace( /\/mcp$/, '' )
			parsed.search = ''
			parsed.hash = ''
			return parsed.toString().replace( /\/$/, '' )
		}

	}

}
